import { useLocation, useNavigate } from 'react-router-dom';

const MobileNavbar = () => {
  const menuItems = [
    { name: 'CRASH', path: '/casino/Spribe/Crash games'},
    { name: 'LOTTERY', path: '/casino/lottery' },
    { name: 'SPORTS', path: '/home' },
    { name: 'OUR CASINO', path: '/casino/Mac88/All' },
    { name: 'LIVE CASINO', path: '/casino/Evolution Gaming/Live Roulette' },
    { name: 'SLOTS', path: '/casino/JDB Gaming/Video Slots' },
    { name: 'FANTASY', path: '/casino/Smartsoft Gaming/Crash Games' },
  ];

  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="w-full shadow-md xl:hidden overflow-x-auto">
      <div className="flex items-center h-12 whitespace-nowrap">
        {menuItems.map((item, index) => {
          const isActive = location.pathname === item.path;

          return (
            <div
              onClick={() => navigate(item.path)}
              key={item.name}
              className={`flex min-w-[calc(100%/7)] items-center flex-shrink-0
        ${isActive ? 'border-t-2 border-body-inverse' : 'border-t-2 border-transparent'}
      `}
            >
              <button className="w-full flex items-center justify-center relative px-3 text-xs md:text-sm font-semibold tracking-wide text-body-inverse hover:text-neutral-300 transition-colors duration-200">
                {item.name === 'CRASH' && (
                  <img
                    src="/icons/aviator.png"
                    alt="Crash"
                    className="h-[26px] max-md:animate-pulse-full md:h-[30px] w-auto mr-1"
                  />
                )}
                <span className="">{item.name}</span>
              </button>

              {index !== menuItems.length - 1 && <span className="h-6 w-px bg-body-inverse/40" />}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MobileNavbar;
